__turbopack_context__.v({
  "button": "IconSystemButton-module-scss-module__1J2sCG__button",
  "icon": "IconSystemButton-module-scss-module__1J2sCG__icon",
  "m": "IconSystemButton-module-scss-module__1J2sCG__m",
  "primary": "IconSystemButton-module-scss-module__1J2sCG__primary",
  "quartiary": "IconSystemButton-module-scss-module__1J2sCG__quartiary",
  "s": "IconSystemButton-module-scss-module__1J2sCG__s",
  "secondary": "IconSystemButton-module-scss-module__1J2sCG__secondary",
  "tertiary": "IconSystemButton-module-scss-module__1J2sCG__tertiary",
  "xs": "IconSystemButton-module-scss-module__1J2sCG__xs",
});
